export default {
  props: {
    shapeLimit: {
      default: null,
      type: Number,
    },
    displayDrawingControl: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      drawingManager: null,
      shapes: [],
      selectedShape: null,
      lastShape: null,
      colors: ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082', '#FFFF00', '#FF0000', '#804000'],
      selectedColor: null,
      lastId: 1,
    };
  },
  methods: {
    showTools(show) {
      this.drawingManager.setOptions({
        drawingControl: this.displayDrawingControl && show,
      });
    },

    setMode(mode) {
      this.drawingManager.setDrawingMode(mode);
    },

    clearSelection() {
      if (this.selectedShape) {
        this.selectedShape.setEditable(false);
        this.selectedShape = null;
      }
    },

    deleteSelectedShape() {
      if (this.selectedShape) {
        this.shapes.splice(
          this.shapes.findIndex((s) => s.id === this.selectedShape.id),
          1
        );
        this.selectedShape.setMap(null);
        this.lastShape = this.selectedShape;
        this.selectedShape = null;
      }
    },

    deleteShapes() {
      if (this.shapes.length > 0) {
        this.shapes.forEach((shape) => {
          shape.setMap(null);
          this.lastShape = shape;
        });
        this.shapes = [];
      } else {
        this.lastShape = null;
      }
    },

    setSelection(shape) {
      this.clearSelection();
      this.selectedShape = shape;
      shape.setEditable(true);
      this.selectColor(shape.get('fillColor') || shape.get('strokeColor'));
    },

    undo() {
      this.lastShape.setMap(this.map);
      this.shapes.push(this.lastShape);
    },

    addShape(shape) {
      shape.id = this.lastId++;
      this.google.maps.event.addListener(shape, 'click', () => {
        this.setSelection(shape);
      });
      this.setSelection(shape);

      this.shapes.push(shape);

      this.lastShape = null;
    },

    setModeColor(mode, prop, color) {
      const options = this.drawingManager.get(mode);
      if (options) {
        options[prop] = color;
        this.drawingManager.set(mode, options);
      }
    },

    selectColor(color) {
      this.selectedColor = color;

      this.setModeColor('polylineOptions', 'strokeColor', color);
      this.setModeColor('rectangleOptions', 'fillColor', color);
      this.setModeColor('circleOptions', 'fillColor', color);
      this.setModeColor('polygonOptions', 'strokeColor', color);
      this.setModeColor('polygonOptions', 'fillColor', color);
    },

    setSelectedShapeColor(color) {
      if (this.selectedShape) {
        if (this.selectedShape.type === google.maps.drawing.OverlayType.POLYLINE) {
          this.selectedShape.set('strokeColor', color);
        } else {
          this.selectedShape.set('strokeColor', color);
          this.selectedShape.set('fillColor', color);
        }
      }
    },

    useColor(color) {
      this.selectColor(color);
      this.setSelectedShapeColor(color);
    },

    calculateCenter(points) {
      const longitudes = points.map((i) => i.lng).sort();
      const latitudes = points.map((i) => i.lat).sort();

      const lowX = latitudes[0];
      const highX = latitudes.slice(-1).pop();
      const lowY = longitudes[0];
      const highY = longitudes.slice(-1).pop();

      return { lat: lowX + (highX - lowX) / 2, lng: lowY + (highY - lowY) / 2 };
    },

    getCoordinates(shape) {
      const coordinates = [];

      shape
        .getPath()
        .getArray()
        .forEach((c) => {
          coordinates.push({
            lat: c.lat(),
            lng: c.lng(),
          });
        });

      return coordinates;
    },
  },
};
